export const authConstants = {
  //login
  LOGIN_USER_ACTION_REQUEST: "LOGIN_USER_ACTION_REQUEST",
  LOGIN_USER_ACTION_SUCCESS: "LOGIN_USER_ACTION_SUCCESS",
  LOGIN_USER_ACTION_FAILURE: "LOGIN_USER_ACTION_FAILURE",

  //signup
  SIGNUP_USER_ACTION_REQUEST: "SIGNUP_USER_ACTION_REQUEST",
  SIGNUP_USER_ACTION_SUCCESS: "SIGNUP_USER_ACTION_SUCCESS",
  SIGNUP_USER_ACTION_FAILURE: "SIGNUP_USER_ACTION_FAILURE",

  //reset password
  RESET_PASSWORD_USER_ACTION_REQUEST: "RESET_PASSWORD_USER_ACTION_REQUEST",
  RESET_PASSWORD_USER_ACTION_SUCCESS: "RESET_PASSWORD_USER_ACTION_SUCCESS",
  RESET_PASSWORD_USER_ACTION_FAILURE: "RESET_PASSWORD_USER_ACTION_FAILURE",

  //reset password confirm
  RESET_PASSWORD_CONFIRM_USER_ACTION_REQUEST:
    "RESET_PASSWORD_CONFIRM_USER_ACTION_REQUEST",
  RESET_PASSWORD_CONFIRM_USER_ACTION_SUCCESS:
    "RESET_PASSWORD_CONFIRM_USER_ACTION_SUCCESS",
  RESET_PASSWORD_CONFIRM_USER_ACTION_FAILURE:
    "RESET_PASSWORD_CONFIRM_USER_ACTION_FAILURE",

  //logout
  LOGOUT_USER_ACTION_REQUEST: "LOGOUT_USER_ACTION_REQUEST",
  LOGOUT_USER_ACTION_SUCCESS: "LOGOUT_USER_ACTION_SUCCESS",
  LOGOUT_USER_ACTION_FAILURE: "LOGOUT_USER_ACTION_FAILURE",

  // select role
  SELECT_ROLE_USER_ACTION_REQUEST: "SELECT_ROLE_USER_ACTION_REQUEST",
  SELECT_ROLE_USER_ACTION_SUCCESS: "SELECT_ROLE_USER_ACTION_SUCCESS",
  SELECT_ROLE_USER_ACTION_FAILURE: "SELECT_ROLE_USER_ACTION_FAILURE",

  //google login
  GOOGLE_LOGIN_USER_ACTION_REQUEST: "GOOGLE_LOGIN_USER_ACTION_REQUEST",
  GOOGLE_LOGIN_USER_ACTION_SUCCESS: "GOOGLE_LOGIN_USER_ACTION_SUCCESS",
  GOOGLE_LOGIN_USER_ACTION_FAILURE: "GOOGLE_LOGIN_USER_ACTION_FAILURE",

  //google login
  MICROSOFT_LOGIN_USER_ACTION_REQUEST: "MICROSOFT_LOGIN_USER_ACTION_REQUEST",
  MICROSOFT_LOGIN_USER_ACTION_SUCCESS: "MICROSOFT_LOGIN_USER_ACTION_SUCCESS",
  MICROSOFT_LOGIN_USER_ACTION_FAILURE: "MICROSOFT_LOGIN_USER_ACTION_FAILURE",

  //user meta data
  USER_META_DATA_REQUEST: "USER_META_DATA_REQUEST",
  USER_META_DATA_SUCCESS: "USER_META_DATA_SUCCESS",
  USER_META_DATA_FAILURE: "USER_META_DATA_FAILURE",

  //user meta data
  UPDATE_USER_META_DATA_REQUEST: "UPDATE_USER_META_DATA_REQUEST",
  UPDATE_USER_META_DATA_SUCCESS: "UPDATE_USER_META_DATA_SUCCESS",
  UPDATE_USER_META_DATA_FAILURE: "UPDATE_USER_META_DATA_FAILURE",

  //user meta data
  GET_LOGGEDIN_USER_META_DATA_REQUEST: "GET_LOGGEDIN_USER_META_DATA_REQUEST",
  GET_LOGGEDIN_USER_META_DATA_SUCCESS: "GET_LOGGEDIN_USER_META_DATA_SUCCESS",
  GET_LOGGEDIN_USER_META_DATA_FAILURE: "GET_LOGGEDIN_USER_META_DATA_FAILURE",

  //user timezone
  UPDATE_USER_TIMEZONE_REQUEST: "UPDATE_USER_TIMEZONE_REQUEST",
  UPDATE_USER_TIMEZONE_SUCCESS: "UPDATE_USER_TIMEZONE_SUCCESS",
  UPDATE_USER_TIMEZONE_FAILURE: "UPDATE_USER_TIMEZONE_FAILURE",

  //reset password confirm
  INVITE_PASSWORD_RESET_CONFIRM_USER_ACTION_REQUEST:
    "INVITE_PASSWORD_RESET_CONFIRM_USER_ACTION_REQUEST",
  INVITE_PASSWORD_RESET_CONFIRM_USER_ACTION_SUCCESS:
    "INVITE_PASSWORD_RESET_CONFIRM_USER_ACTION_SUCCESS",
  INVITE_PASSWORD_RESET_CONFIRM_USER_ACTION_FAILURE:
    "INVITE_PASSWORD_RESET_CONFIRM_USER_ACTION_FAILURE",
};
